import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify';
import firebase from 'firebase';
import router from './router'

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBNNgMYXzEVJhbBUY8dgCpX8AG2xfaumHk",
  authDomain: "daily-hiatus.firebaseapp.com",
  projectId: "daily-hiatus",
  storageBucket: "daily-hiatus.appspot.com",
  messagingSenderId: "165178624341",
  appId: "1:165178624341:web:d05a5454c1fafa75ae07dc"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

new Vue({
  vuetify,
  render: h => h(App),
  router,
  data: {
    activeSection: 0,
    inTransition: false,
  }
}).$mount('#app')
